import { includes, map } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import FormControlErrorMessage from '../utils/FormControlErrorMessage';
import CheckboxNormal from './base/CheckboxNormal';
import useT from '../utils/Translations/useT';
const CheckboxGroup = ({ options, errorMessage, itemLabelPropName = 'label', itemValuePropName = 'value', isDisabled = false, isOptionDisabled, inline = false, onChange = null, value = [], hasSelectAll = false, ...rest }) => {
    const t = useT();
    const [isSelectAll, setIsSelectAll] = useState((value === null || value === void 0 ? void 0 : value.length) === options.length);
    useEffect(() => {
        const changed = value.filter(item => options.some(option => option[itemValuePropName] === item));
        if (onChange && changed.length !== value.length) {
            onChange(changed);
        }
    }, [options, itemValuePropName, onChange, value]);
    const handleOnChange = useCallback(index => () => {
        if (onChange) {
            const changed = [...value];
            const pos = changed.indexOf(options[index][itemValuePropName]);
            if (pos > -1) {
                changed.splice(pos, 1);
            }
            else {
                changed.push(options[index][itemValuePropName]);
            }
            onChange(changed);
            if (changed.length === options.length) {
                setIsSelectAll(true);
            }
            else {
                setIsSelectAll(false);
            }
        }
    }, [onChange, options, itemValuePropName, value]);
    const handleSelectAll = useCallback(() => {
        if (onChange) {
            if (isSelectAll) {
                onChange([]);
            }
            else {
                onChange(map(options, itemValuePropName));
            }
            setIsSelectAll(!isSelectAll);
        }
    }, [onChange, setIsSelectAll, isSelectAll, options, itemValuePropName]);
    return (<div className="mb-15">
      {hasSelectAll && (<CheckboxNormal disabled={isDisabled} inline={inline} label={t('Select All')} value={isSelectAll} onChange={handleSelectAll}/>)}
      {options.map((field, index) => (<CheckboxNormal {...rest} key={`${String(index)}-${field[itemValuePropName]}`} additionalComponent={field === null || field === void 0 ? void 0 : field.additionalComponent} disabled={isDisabled || (isOptionDisabled && isOptionDisabled(field))} inline={inline} label={field[itemLabelPropName]} name={field.name} value={includes(value, field[itemValuePropName])} onChange={handleOnChange(index)}/>))}
      {errorMessage && <FormControlErrorMessage errorMessage={errorMessage}/>}
    </div>);
};
export default CheckboxGroup;
